export default "__VITE_ASSET__9b01be78__"